<template>
  <div class="home">
    <div class="home-main">
      <div class="home-title">{{user.project}}</div>
      <div class="info">
        <img :src="user.avatar" alt />
        <div class="userName">{{user.nickname}}</div>
      </div>
      <a class="navItem" :href="herf">
        <div class="enter">进入课程</div>
      </a>
      <!-- 登出 -->
      <div class="loginOut" @click="loginOut">退出登录</div>
      <div class="home-bottom">
        <img src="@/assets/logo.png" alt />
        <div>阿基古鲁教育科技</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getShareInfo } from '@/utils/share'
import { courseTypeList } from '@/api/course/index.js'
import { userInfo } from '@/api/login/index'
export default {
  data() {
    return {
      // 用户信息
      user: {},
      herf: '#/latestCourse',
      typeList: []
    }
  },
  activated() {
    getShareInfo()
    // this.getCourseTypeList()
    this.getUserInfo()
  },
  deactivated() {},
  methods: {
    // 获取用户信息
    getUserInfo() {
      userInfo().then((res) => {
        const { code, obj, message } = res
        if (code == 200) {
          this.user = obj.user
          localStorage.setItem('user', JSON.stringify(this.user))
          // if (
          //   this.user.id == 16 ||
          //   this.user.id == 21 ||
          //   this.user.id == 28 ||
          //   this.user.id == 41 ||
          //   this.user.id == 19
          // ) {
          //   this.herf = '#/latestCourse'
          // } else {
          //   this.herf = '#/find'
          // }
        } else {
          this.$message.error(message)
        }
      })
    },
    // 登出
    loginOut() {
      this.$router.push('/login')
      localStorage.removeItem('token')
      localStorage.removeItem('courseCover')
      localStorage.removeItem('ID')
      localStorage.removeItem('id')
    }
    // 获取课程类目
    // getCourseTypeList() {
    //   courseTypeList().then((res) => {
    //     const { obj, code, message } = res
    //     if (code == 200) {
    //       this.typeList = obj
    //     } else {
    //       this.$message.error(message)
    //     }
    //   })
    // }
  }
}
</script>

<style scoped>
@import './index.css';
</style>